import * as React from 'react';
import { AwardsSources, AwardsWrapper } from '../../components/Awards';
import { AwardCard } from '../../components/AwardCard';
import { useSelector } from 'react-redux';
import { getDeveloperAwards } from '../../selectors/developerV2';
import { trackShowAwardsBlock } from './tracking';

export const Awards = () => {
  const awards = useSelector(getDeveloperAwards);

  if (!awards) {
    return null;
  }

  return (
    <AwardsWrapper
      id="awards"
      title="Награды"
      sourceTooltip={<AwardsSources sources={awards.sources} />}
      sourceLabel={awards.text}
      onShow={trackShowAwardsBlock}
    >
      {awards.awards.map((award, index) => (
        <AwardCard key={index} title={award.title} image={award.imageUrl} />
      ))}
    </AwardsWrapper>
  );
};
